module.exports = __webpack_public_path__ + "img/8-kaksin.3a835892.jpg";